export enum DialogResult {

    Update = 'UPDATE',
    UpdateWithRedirect = 'UPDATE_WITH_REDIRECT',
    Nothing = 'NOTHING',
    
}